<template lang="pug">
.otpgroup-search.module-layout
	h1.otpgroup-search__title Searched phrase
	.otpgroup-search__field
		VueSearch(type="PAGE", v-model="model.term", :search-items="searchItems", @input="autosuggest", @submit="search")
	.search__field.sr-only(ref="top", tabindex="0")
	.otpgroup-search-result(v-if="!technicalError && !loading && hits && hits.length", ref="searchResults")
		p.otpgroup-search-result__number-of-hits #[strong {{ totalNumberOfHits }} hits]
		.otpgroup-search-result__hits
			VueSearchResult(v-for="hit in resultHits", :search-result="hit", :key="hit.mid")
		VuePagination(v-model="currentPage", :disabled="loading", :total-rows="totalNumberOfHits", @input="changePage")
	SearchNotFound(v-if="!technicalError && resultHits && resultHits.length == 0", :query="model.term")
	TechnicalError(v-if="technicalError")
		template(slot="technical-error-title") Oops!
		p.sf-text(slot="technical-error-text") Sorry, you can't search right now.#[br]We are already working on it, please come back later.
	.otpgroup-search-loader(v-if="loading")
		VueSpinner
</template>

<script>
import debounce from 'lodash-es/debounce';
import searchApi from '../../api/search-api';
import VueSearch from '@ui-common/vue-search';
import VueSearchResult from '@ui-common/vue-search-result';
import SearchNotFound from './search-not-found/search-not-found.vue';
import VuePagination from '@ui-common/vue-pagination';
import VueSpinner from '@ui-common/vue-spinner';
import query from 'query-string';
import TechnicalError from '../../common/components/technical-error/technical-error.vue';
const SUGGEST_MIN_LENGTH = 3;
const MAX_HITS = 1000;
export default {
	data: () => ({
		model: {
			term: null
		},
		currentPage: 1,
		hits: null,
		totalNumberOfHits: null,
		technicalError: false,
		searchItems: null,
		loading: false
	}),
	components: {
		VueSearch,
		VueSearchResult,
		SearchNotFound,
		VuePagination,
		VueSpinner,
		TechnicalError
	},
	computed: {
		resultHits() {
			return (
				this.hits &&
				this.hits.map((hit) => {
					return {
						title: hit.title,
						url: hit.url,
						text: hit.highlight,
						isFileResult: hit.extension
					};
				})
			);
		}
	},
	methods: {
		autosuggest: debounce(async function (term) {
			if (term.length >= SUGGEST_MIN_LENGTH && !this.loading) {
				const response = await searchApi.getSuggestions(term);
				if (response && response.data) {
					this.searchItems = response.data.map((hit) => ({ label: hit }));
				}
			}
		}, 300),
		async search(term) {
			try {
				this.loading = true;
				searchApi.cancelSuggestion();
				this.currentPage = 1;
				const response = await searchApi.search(term);
				this.hits = response.data.search.hits || [];
				this.model.term = term;
				this.totalNumberOfHits = Math.min(response.data.search.totalNumberOfHits, MAX_HITS);
				await this.$nextTick();
				this.$refs.top.focus();
			} catch (err) {
				this.technicalError = true;
			} finally {
				this.loading = false;
			}
		},
		async changePage(page) {
			try {
				this.loading = true;
				this.currentPage = page;
				const response = await searchApi.search(this.model.term, this.currentPage - 1);
				this.hits = response.data.search.hits;
				this.totalNumberOfHits = Math.min(response.data.search.totalNumberOfHits, MAX_HITS);
				await this.$nextTick();
				this.$refs.top.focus();
			} catch (err) {
				this.technicalError = true;
			} finally {
				this.loading = false;
			}
		},
		searchFromUrl() {
			const urlParams = query.parse(window.location.search.substring(1));
			if (urlParams.searchQueryValue) {
				this.model.term = urlParams.searchQueryValue;
				this.search(this.model.term);
			}
		}
	},
	created() {
		this.searchFromUrl();
	}
};
</script>

<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.otpgroup-search {
	@include media('>=desktop') {
		padding: 56px 122px;
	}

	@include media('>=desktop-lg') {
		padding-left: 192px;
		padding-right: 192px;
	}
}

.otpgroup-search-loader {
	padding: 32px 0 126px;
}

.otpgroup-search__title {
	font-size: 28px;
	line-height: 32px;
	margin-bottom: 24px;

	@include media('>=tablet') {
		font-size: 32px;
		line-height: 40px;
		margin-bottom: 32px;
	}
}

.otpgroup-search__field {
	margin-bottom: 16px;
}

.otpgroup-search-result__number-of-hits {
	margin-bottom: 56px;

	@include media('>=tablet') {
		margin-bottom: 32px;
	}
}

.otpgroup-search-result__hits {
	margin-bottom: 36px;

	@include media('>=tablet') {
		margin-bottom: 80px;
	}
}

.otpgroup-search-result__hits ::v-deep .sf-search-result .sf-text-fineprint {
	@include media('<tablet') {
		display: none;
	}
}
</style>
